export class ImageLightbox {
  constructor () {
    return {
      restrict: 'A',
      replace: true,
      link: function postLink(scope, element, attrs) {
        var activityIndicatorOn = () => {
            $('<div id="imagelightbox-loading"><div></div></div>').appendTo('body');
          },

          activityIndicatorOff = () => {
            $('#imagelightbox-loading').remove();
          },

          overlayOn = () => {
            $('<div id="imagelightbox-overlay"></div>').appendTo('body');
          },

          overlayOff = () => {
            $('#imagelightbox-overlay').remove();
          },

          closeButtonOn = (instance) => {
            $('<a href="#" id="imagelightbox-close"></a>').appendTo('body').on('click', () => {
              $(this).remove();
              instance.quitImageLightbox();
              return false;
            });
          },

          closeButtonOff = () => {
            $('#imagelightbox-close').remove();
          },

          instanceF = $('a[data-imagelightbox="f"]').imageLightbox({
            onStart: function () {
              overlayOn();
              closeButtonOn(instanceF);
            },

            onEnd: function () {
              overlayOff();
              closeButtonOff();
              activityIndicatorOff();
            },

            onLoadStart: function () {
              activityIndicatorOn();
            },

            onLoadEnd: function () {
              activityIndicatorOff();
            }
          });
      }
    };
  }
}
